import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import styles from "./style.module.scss";
import LogoPlaceholder from '../../../../../../../images/v2/processor-placeholder-logo.png';
import useProcessorStore from "../../../../../stores/processor";
import config from "../../../../../../config";

const Fallback = () => (
  <img src={LogoPlaceholder} alt="Logo placeholder" />
);

export const AddLogo = () => {
  const { setFieldValue, values, errors, touched } = useFormikContext();
  const [src, setSrc] = useState("");
  const activeBank = useProcessorStore((state) => state.activeBank);

  const handleOnFileChange = (event) => {
    if (event.target.files[0]) {
      setFieldValue("logo_image", event.target.files[0]);
      setSrc(URL.createObjectURL(event.target.files[0]));
    }
  };

  const handleRemoveLogo = () => {
    setSrc(null);
    setFieldValue("logo_image", "");
  };

  useEffect(() => {
    setSrc(activeBank ? `${config.paymentcloud.STRATUS_URL}bank-image/${activeBank?.id}` : "")
  }, [activeBank])

  return (
    <div
      className={`${styles.orgLogoContainer} ${src ? styles.logoSet : styles.placeHolderSet}`}
    >
      <div className={styles.orgLogoImageContainer}>
        {src ? <img src={src} onError={() => setSrc("")} /> : <Fallback />}
        <div className={styles.shadow}></div>
      </div>
      <div className={styles.inputLabelContainer}>
        <label htmlFor="logo_image">
          <p className={styles.title}>
            Add logo <span>(optional)</span>
          </p>
          <input
            id="logo_image"
            name="logo_image"
            type="file"
            className={styles.fileInput}
            onChange={handleOnFileChange}
          />
        </label>
        {src && (
          <span onClick={handleRemoveLogo} className={styles.removeLogo}>
            Remove
          </span>
        )}
      </div>
    </div>
  );
};

export default AddLogo;
